import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import useAddressSearch, { AddressOption } from "../../utils/useAddressSearch";
import Select from "../Select/Select";

function Geolocation({
  value = "",
  onChange = () => {},
  placeholder,
  ...props
}: any) {
  const { t } = useTranslation();
  const { loadOptions, resolveAddress } = useAddressSearch();

  /* On est obligé de passer par le script google car si on essaye de faire une requete fetch sur l'url problème de CORS
   * sur l'url que l'on veut utiliser
   */
  useEffect(() => {
    const script = document.createElement("script");

    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBoabCFYUx-SQW3QtY0WmkRRuzsfhmQtCs&libraries=places`; // &libraries=places
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Les appelants attendent `row.location` (google.maps.LatLng), résolu
  // uniquement à la sélection
  const handleChange = async (val: string, row?: AddressOption) => {
    if (!row?.placePrediction) {
      onChange(val, row);
      return;
    }
    try {
      const resolved = await resolveAddress(row);
      if (resolved) {
        onChange(resolved.address, {
          label: resolved.address,
          value: resolved.address,
          location: resolved.location,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const defaultOptions = value ? [{ label: value, value }] : [];

  return (
    <Select
      placeholder={placeholder || t("forms.geoTypeToSearch")}
      value={value}
      defaultOptions={defaultOptions}
      onChange={handleChange}
      loadOptions={loadOptions}
      {...props}
    />
  );
}

export default Geolocation;
